<template>
  <div class="bg">
    <div class="wrap">
      <div class="head">
        购买指导：
        <span>选择产品</span>
        <span>扫码支付</span>支付成功、立即使用
      </div>
      <div class="main">
        <h2 class="main-tit">
          账号：
          <strong class="font-blue">{{userName}}</strong>
          <a class="btn-invoice fr" href="###" @click="openInvoice">开具发票</a>
        </h2>
        <div class="main-table">
          <div class="licheckbox" style="bottom: 190px; font-size: 12px;">
            <span @click="isZQ=!isZQ;isCE = !isCE" v-show="foldedPeriod && foldedPeriod >0" class="licheckbox-label" :class="isZQ?'selected':''">我同意将大智慧现有低版本剩余期限按实际价值折算，合计{{ foldedPeriod }}天累加至新产品有效期内</span><a class="licheckbox-btn-more" v-show="foldedPeriod && foldedPeriod >0" @click="isZQ?(showDiscount=!showDiscount):''">展开明细</a>
          </div>
          <div class="licheckbox" style="bottom: 140px; font-size: 12px;">
            <span @click="isCE=!isCE;isZQ = !isZQ" v-show="foldedPeriod && foldedPeriod >0" class="licheckbox-label" :class="isCE?'selected':''">我同意将大智慧现有低版本剩余期限按实际价值折算后进行补差升级</span><a class="licheckbox-btn-more" v-show="foldedPeriod && foldedPeriod >0" @click="isCE?(showCE=!showCE):''">展开明细</a>
          </div>

          <div class="main-table-cont">
            <ul class="table-cont-column" v-if="!isSingle">
              <li class="th">产品</li>
              <li
                class="td"
                v-for="product in products"
                :key="product.id"
                :class="{selected: product.id==productId}"
                @click="selectProduct(product.id)"
              >{{product.name}}</li>
              <template v-if="actCouponProducts.length>0">
                <li
                  class="td"
                  v-for="(item,index) in actCouponProducts"
                  :key="item.productId"
                  :class="{selected: item.productId==productId}"
                  @click="selectActProduct(item.productId,index)"
                >{{item.productName}}</li>
              </template>

            </ul>
            <ul class="table-cont-column" v-else>
              <li class="th">产品</li>
              <li class="column-pdt" v-for="product in products" :key="product.id">
                <p class="column-pdt-tit">{{product.name}}</p>
                <a href="javascript:void(0);" class="fr" @click="buyMore">购买更多产品</a>
              </li>
            </ul>
            <ul class="table-cont-column">
              <li class="th">期限</li>
              <template v-if="actCouponProducts.length>=0&&actCouponRightD">
                <li  class="actCouponr-box" >

                  <div class="tle-box">{{actCouponProducts[selectActPIndex].productName}}包含：</div>
                  <div class="p-list" >
                     <p v-for="item in actCouponProducts[selectActPIndex].subProductPriceVos">
                      {{item.productName}} {{item.oriPrice}}元/{{item.month}}个月
                     </p>
                  </div>
                  <div class="price-box">原价：{{actCouponProducts[selectActPIndex].oriPrice}}元</div>
                </li>
              </template>

              <template v-else>
                <li class="duration-column price-column">
                  <div v-for="(price, index) in prices" :key="price.month">
                    <span
                      :class="{selected:price.month==monthCount }"
                      @click="selectMonth(price.month, index)"
                    >
                    <template v-if="price.month>=12">{{price.month | monthToYear}}年</template>
                    <template v-else>{{price.month}}个月</template>
                    </span>
                  </div>
                </li>
                <li class="column-totalPrice">
                  <div
                    class="totalPrice-wrap"
                    v-for="price in prices"
                    :key="price.month"
                    v-show="price.month == monthCount"
                  >
                    价格：<span
                      class="totalPrice-org"
                      :class="{'totalPrice-org-line' : price.curPrice && price.oriPrice != price.curPrice}"
                    >{{price.oriPrice}}元/<template v-if="price.month>=12">{{price.month | monthToYear}}年</template><template v-else>{{price.month}}个月</template>
                    </span>
                    <!-- <p
                      class="totalPrice-cur font-red"
                      v-if="price.curPrice && price.oriPrice != price.curPrice"
                    >{{price.curPrice}}元/年({{price.remark}})</p> -->
                  </div>
                </li>
                <!-- <li class="text" v-show="discountText"> -->
                  <!-- <a class="btn-close" @click="discountText=false"></a> -->
                  <!-- <p v-for="text in discountList" :key="text.orderId">您的《{{text.productName}}》剩余期限{{text.remainLength}}个月，可折换价值{{text.convertMoney}}元。</p> -->
                  <!-- <div class="discount-item" :class="{selected: discountIndex==0}" @click="discountIndex=0">折换《大智慧专业版》120天</div> -->
                  <!-- <div class="discount-item" :class="{selected: discountIndex==1}" @click="discountIndex=1">使用补差升级优惠</div>
                  <div class="discount-item" :class="{selected: discountIndex==2}" @click="discountIndex=2">不使用折换优惠</div>
                </li> -->
              </template>

            </ul>
          </div>
          <ul class="table-cont-column discout-box" v-if="actCouponRightD">
            <div class="money-box" >
              <p>总计：<span><em>{{actCouponProducts[selectActPIndex].curPrice }}</em>元</span></p>
              <p>{{discountIndex === 1 ? '已折算：' : '已优惠：'}}<span>{{actCouponProducts[selectActPIndex].curPrice | twinPointAmountFormat(actCouponProducts[selectActPIndex].oriPrice)}}元</span></p>
            </div>
          </ul>
          <ul class="table-cont-column discout-box" v-else>
            <!-- <li class="duration-column" v-show="this.showMore"><a class="btn-more" v-show="this.showMore" @click="discountText=!discountText" :class="{actived:showMore}">更多 ></a></li> -->
            <div class="money-box" v-if="prices.length > 0">
              <p>总计：<span v-if="prices[priceIndex].subProductPriceVos != null"><em>{{prices[priceIndex].oriPrice | floatSub(convertMoneyEnd)}}</em>元</span>
              <span v-else><em>{{prices[priceIndex].curPrice | floatSub(convertMoneyEnd)}}</em>元</span>
              </p>

              <p v-if="discountIndex === 1">已折算：<span v-if="prices[priceIndex].subProductPriceVos != null ">{{0-convertMoneyEnd}}元</span>
              <span v-else>{{(prices[priceIndex].curPrice) | getDisCountMoney(prices[priceIndex].oriPrice,0,0,convertMoneyEnd)}}</span>
              </p>
              <p v-else>已优惠：<span v-if="prices[priceIndex].subProductPriceVos != null ">{{0-convertMoneyEnd}}元</span>
              <span v-else>{{(prices[priceIndex].curPrice) | getDisCountMoney(prices[priceIndex].oriPrice,0,0,convertMoneyEnd)}}</span></p>
            </div>
          </ul>
          <a
            href="###"
            class="main-btn"
            :class="{'disabled': !protocolActive}"
            @click="orderConfirm"
          >立即购买</a>
        </div>
      </div>
      <div class="foot">
        <!-- <div class="foot-img fr">
          <img :src="wechatUrl"/>
          <p>
            扫一扫添加
            <br />企业微信在线咨询
          </p>
        </div> -->
        <div class="foot-select">
          <router-link :to="'/protocol'" target="_blank">使用软件许可协议</router-link>
          <!-- <a href="agreement.html" class="font-blue" target="_blank">使用软件许可协议</a> -->
          <span
            class="select-btn fr"
            :class="{selected: protocolActive}"
            @click="confirmProtocol"
          >我已仔细阅读相关协议，对其内容表示确认。</span>
        </div>
        <p class="foot-tips">
          如遇到支付问题，可随时拨打
          <strong class="font-blue">021-20219999</strong>，客服将第一时间帮你解决。
          <br />如需了解详情可点击进入大智慧官网
          <a href="javascript:void(0);" id="toWebsite">www.gw.com.cn</a>
        </p>
      </div>
      <!-- 电子发票组件 -->
      <invoice ref="invoice" />

      <!-- 权限并行提示 -->
      <div class="pop" v-show="showDiscount||showQXNOCan||showQXCan||showQXConfirm||showCE">
        <!-- 低买高 -->
        <div class="pop-win-warning"  v-show="showDiscount">
          <span class="pop-win-close" @click="showDiscount=false">x</span>
          <h5>【温馨提示】</h5>
          <p>为了购买新版本的大智慧，您需要将现有低版本大智慧的剩余期限按实际价值进行折算，并累计至新产品的有效期中。现有产品如下：</p>
          <ul>
            <div
                v-for="item in discountList"
                :key="item.productId"
              >
              <li>{{ item.productName }} <span class="fr">+{{item.foldPeriodDayLength}}天</span></li>
            </div>
            <li class="total">合计可折期限 <span class="fr">当前购买产品&nbsp;&nbsp;&nbsp;&nbsp;+{{foldedPeriod}}天</span></li>
          </ul>
          <!-- <div class="qx-result"><strong>+折期后，当前所购产品有效期{{powerStartDt | dateFormat("yyyy-MM-dd")}}至{{ productSentPowerTime(powerEndDt,foldedPeriod) | dateFormat("yyyy-MM-dd")}}</strong></div> -->
          <!-- <div class="qx-btns">
            <a @click="showDiscount=false">再考虑下</a>
            <a class="qx-btns-ok" @click="showDiscount=false;isQXagree=true">同意折期</a>
          </div> -->
        </div>
        <div class="pop-win-warning"  v-show="showCE">
          <span class="pop-win-close" @click="showCE=false">x</span>
          <h5>【温馨提示】</h5>
          <p>您可以将现有大智慧低版本剩余期限按实际价值折算后进行补差升级，具体可优惠金额如下如下：</p>
          <ul>
            <div
                v-for="item in discountList"
                :key="item.productId"
              >
              <li style="color: #D07D00">您的《{{ item.productName }}》剩余期限{{item.remainLength}}天，价值{{ item.convertMoney }}元。 <span class="fr">¥ -{{item.convertMoney}}</span></li>
            </div>
          </ul>
        </div>
        <!-- 高买低 -->
        <div class="pop-win-warning pop-win-warning-s" v-show="showQXNOCan">
          <span class="pop-win-close" @click="showQXNOCan=false">x</span>
          <p>提示：</p>
          <div class="qx-result">系统检测到您已拥有其他版本大智慧，本产品不可购买，如有疑问可联系客服。</div>
          <div class="qx-btns">
            <a @click="showQXNOCan=false" class="qx-btns-ok">我知道了</a>
          </div>
        </div>
        <!-- 高买低暂存 -->
        <div class="pop-win-warning pop-win-warning-s" v-show="showQXCan">
          <span class="pop-win-close" @click="showQXCan=false">x</span>
          <p>提示：</p>
          <div class="qx-result">系统检测到您已拥有其他版本大智慧，如继续购买该产品将优先消耗高版本大智慧产品，该产品有效期将为您预存在“我的产品”中。</div>
          <div class="qx-btns">
            <a @click="showQXCan=false" class="qx-btns-ok">我已知晓，继续购买</a>
          </div>
        </div>

        <!-- 权限并行确认弹框 -->
        <div class="pop-win-warning pop-win-confirm" v-show="showQXConfirm">
          <span class="pop-win-close" @click="showQXConfirm=false">x</span>
          <h6>【温馨提示】</h6>
          <p>您需要先同意，将现有低版本大智慧剩余期限按实际价值进行折期或者补差才可购买新版本大智慧。</p>
          <div class="pop-win-btns flex">
            <a href="javascript:;" @click="showQXConfirm=false">取消</a>
            <a href="javascript:;" class="btn-ok" @click="showQXConfirm=false">去折期或补差</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  data() {
    return {
      wechatUrl: require("@/assets/images/common/wechat.png"),
      protocolActive: true,
      token: "",
      pids: null,
      source: null,
      isSingle: false,
      userName: null,
      productId: null,//默认产品或选中的产品
      monthCount: 12,//默认期限或选中的期限
      products: [],
      prices: [],
      actCouponProducts:[],//2022年新增需求feature-SCHT-130优惠券 519活动入口
      selectActPIndex:0,
      //actCouponRightD:false,
      priceIndex: 0,
      discountList: [],
      discountText: false,
      convertMoney: 0,
      discountIndex:2,
      //showMore: false,
      s: this.$route.query.s,
      //showQX:false,
      foldedPeriod: 0,
      showDiscount: false,
      showCE: false,
      showQXCan:false,
      showQXNOCan:false,
      isZQ:true,
      isCE: false,//补差
      showQXConfirm:false,

      powerStartDt: null,
      powerEndDt: null,
    };
  },
  created() {
    document.title = "PC购买入口";
    var token = this.$route.query.token;
    var pids = this.$route.query.pids;
    var month =  this.$route.query.month;
    if (token == null || token == "") {
      console.log("请求token为空");
      window.close();
    }
    this.token = token;
    this.monthCount = month || 12
    if (pids) {
      this.pids = pids;
    }
    if (!this.s) {
      this.s = "";
    }

    this.getData();
  },
  computed: {
    convertMoneyEnd () {
      return this.discountIndex ===1 ? this.convertMoney : 0
    },
    actCouponRightD () {
      let that = this
      let bool = false;
      this.actCouponProducts.map(function(t){
        if(that.productId==t.productId){
          bool = true
        }
      })
      return bool
    }
  },
  methods: {
    getData() {
      var params = {
        token: this.token,
      };
      if (this.pids) {
        params.pids = this.pids;
      }
      this.$get("/client/function", params)
        .then(response => {
          if (response.code === 0) {
            // data.length >0
            this.$storage.saveUserName(response.data.userName);
            this.userName = response.data.userName;
            this.productId = response.data.productId;
            this.products = response.data.products;
            this.prices = response.data.prices;
            this.monthCount = response.data.prices[0].month
            this.powerStartDt = response.data.prices[0].powerStartDt
            this.powerEndDt = response.data.prices[0].powerEndDt
            if(this.productId  === 197) {
              this.prices = this.prices.slice().reverse()
              this.monthCount = this.prices[0].month

            }
            if(this.productId === 113){
              if(this.prices[0].month==3){
                this.prices.shift()
              }
            }
            // this.getActCouponData()////2022年新增需求feature-SCHT-130优惠券 519活动入口
            if (this.products.length == 1) {
              this.isSingle = true;
            } else {
              this.isSingle = false;
            }
            this.getDiscount();
          } else if (response.code === 101) {
            window.close();
          } else {
            alert(response.msg);
            window.close();
          }
        })
        .catch(err => {
          //alert("网络异常，请稍后重试");
          window.close();
        });
    },
    getActCouponData(){

      var params = {
        token: this.token,
      };
      this.$get("/client/activityProduct",params)
        .then(response => {
          if (response.code === 0) {
            this.actCouponProducts = response.data
          } else if (response.code === 101) {
            window.close();
          } else {
            alert(response.msg);
            window.close();
          }
        })
        .catch(err => {
          //alert("网络异常，请稍后重试");
          window.close();
        });
      //this.actCouponProducts = actCouponProducts

    },
    selectProduct(productId) {
      this.productId = productId;
      this.monthCount = 12;
      this.$get("/product/price?id=" + productId)
        .then(response => {
          if (response.code === 0) {
            this.prices = response.data;
            if(productId === 197) {   //||productId === 116
              this.prices = this.prices.slice().reverse()
            }
            if(productId === 113){
              this.prices.shift()
            }
            for(var i in this.prices){
              if(this.prices[i].month === this.monthCount){
                this.priceIndex = i;
              }
            }
            // this.priceIndex = 0
            // this.monthCount = this.prices[this.priceIndex].month;
            // this.powerStartDt = this.prices[this.priceIndex].powerStartDt;
            // this.powerEndDt = this.prices[this.priceIndex].powerEndDt;
            this.getDiscount();
          } else if (!(response.code == 100 || response.code == 101)) {
            this.$alert(response.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    selectActProduct(productId,index){
      this.productId = productId;
      this.monthCount = 12;
      this.selectActPIndex = index
    },
    selectMonth(monthCount, index) {
      this.monthCount = monthCount;
      this.priceIndex = index;
      this.powerStartDt = this.prices[this.priceIndex].powerStartDt;
      this.powerEndDt = this.prices[this.priceIndex].powerEndDt;
      this.getDiscount();
    },
    openInvoice() {
      this.$refs.invoice.openInvoice();
    },
    confirmProtocol() {
      this.protocolActive = !this.protocolActive;
    },
    orderConfirm() {
      if (!this.protocolActive) {
        this.$alert(
          "请仔细阅读“上海大智慧信息科技有限公司软件产品许可使用协议”，阅读结束后同意请选中“我同意协议”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }
      if(this.foldedPeriod > 0 && !(this.isZQ||this.isCE)){
        this.showQXConfirm = true
        return false;
      }
      // 保存订单并跳转到支付页面
      var params = {
        productId: this.productId,
        monthCount: this.monthCount,
        invoiceTitleType: this.$refs.invoice.invoiceTitleType,
        convertMoney: this.convertMoney,
        questionsId: '0',
        foldedPeriodDayNum: this.foldedPeriod,
        buySource: this.s
      };
      if (this.source) {
        params.source = this.source;
      }
      params.orderType = 0
      if(this.foldedPeriod > 0){
        if (this.isZQ) {
          params.orderType = 2
        }
        if(this.isCE){
          params.orderType = 1
        }
      }
      // this.$post("/order/save", params)
      if (this.productId === 335) {
        this.$get('user/checkMobile').then(res =>{
          if(res.code === 0) {
            this.$post("/order/save", params)
            .then(response => {
              if (response.code === 0) {
                this.$router.push("/client/order/" + response.data.id);
              } else if (response.code != 100) {
                this.$alert(response.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(err => {
              alert("网络异常，请稍后重试");
            });
          } else {
             this.$alert('您购买的产品需绑定手机号码认证之后才能提供服务，请前往pay.dzh.com.cn/pay-mall登陆大智慧账号完成手机号码绑定，技术客服热点021-20219997', "提示", {
              confirmButtonText: "确定"
            });
          }
        })
      } else {
        this.$post("/order/save", params)
        .then(response => {
          if (response.code === 0) {
            this.$router.push("/client/order/" + response.data.id);
          } else if (response.code != 100) {
            this.$alert(response.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
      }
    },
    buyMore(){
      var params = {token: this.token}
      if (this.s) {
        params.s = this.s;
      }
      this.$router.push({path: '/client/product.html', query: params})
      location.reload();
    },
    getDiscount() {
      var params = {
        id: this.productId
      };
      if (this.monthCount) {
        params.month = this.monthCount
      }
      // this.showMore = false;
      this.discountIndex = 2;
      this.discountText = false

      this.$get("/order/orderUpgradeCalc", params)
        .then(response => {
          if (response.code === 0) {
            var checkCode = response.data.powerCheckCode
            if(checkCode == 1 || checkCode == 12 || checkCode == 2 || checkCode == 0){
              if(checkCode == 1 || checkCode == 0){
                this.showDiscount = false;
                this.showQXCan = false;
                this.showQXNOCan = false;
              }
              if(checkCode == 12 || checkCode == 2){
                this.showQXCan = true;
                this.showQXNOCan = false;
                this.showDiscount = false;
              }
              this.discountList = response.data.orderVoucherGroupVoList;
              this.foldedPeriod = response.data.foldedPeriod;
              if(this.discountList && this.discountList.length > 0){
                this.convertMoney = this.discountList.reduce((pre, cur) =>{
                return pre + cur.convertMoney
              }, 0)
              }            
            } else if(checkCode == 3){
              this.showQXNOCan = true;
              this.showQXCan = false;
              this.showDiscount = false;
              this.showCE = false;
              this.foldedPeriod = 0;
              this.convertMoney = 0
            }
          } else {
            this.convertMoney = 0
            this.foldedPeriod = 0
            this.showQXCan = false;
            this.showQXNOCan = false;
            this.showDiscount = false;
          }
        })
    },
    productSentPowerTime(val1,val2){
      return val1 + val2*24*60*60*1000
    }
  },
  // watch: {
  //   $route (to, from) {
  //     this.$router.go(0);
  //   }
  // },
  components: {
    Invoice
  },
  mounted() {
    document.getElementsByTagName("body")[0].className="bodyWidth";
  },
  beforeDestroy(){
    document.body.removeAttribute("class","bodyWidth");
  }
};
</script>

<style lang="scss">
.bodyWidth{min-width: 300px;}
</style>
<style lang="scss" scoped>
.main{margin-top: 0;margin-bottom: 0;}
.btn-more{font-size:16px;color:#646464;margin:8px 0 0 0;display:inline-block;}
.btn-more:active,.btn-more:hover,.btn-more.actived{color:#2196f3;}
.btn-close{width:20px;height:20px;right:6px;top:6px;color:#fff;background:#b3b3b3;border-radius:0;font-weight:100;line-height:19px;}
.actCouponr-box{
  padding: 12px;
  box-sizing: border-box;
  .tle-box{

  }
  .p-list{
    padding: 20px 0;
  }
  .price-box{}
}
.price-column{
  max-width: 184px;
  padding-right: 0;
  span{
    padding-left: 20px;
    margin-right: 10px;
  }
}
.pop-win-warning{
  position:fixed;
  left:50%;top:50%;
  background:#fff;
  border-radius:10px;
  width:600px;
  padding:15px 20px 20px;
  box-sizing:border-box;
  font-size:16px;
  color:#222;
  transform:translate(-50%,-50%);
  &.pop-win-warning-s{
    width:500px;
  }
  &.pop-win-confirm{
    width:420px;
    h6{
      font-size:16px;
      margin-bottom:25px;
      text-align:center;
    }
    p{
      padding:0 20px;font-size:20px;line-height:28px;
    }
    .pop-win-btns.flex{
        display:flex;
        margin-top:40px;
        a{
          line-height:40px;
          flex:1;
          margin:0 10px;
          background:#E9E9E9;font-size:16px;text-align:center;border-radius:6px;color:#666;
          &.btn-ok{
            background:#377DFB;color:#fff;
          }
        }
    }
  }
  .pop-win-close{
    position:absolute;
    right:10px;
    top:10px;
    background:#D8D8D8;
    width:20px;height:20px;
    line-height:20px;
    text-align:center;
    color:#fff;
    cursor:pointer;
    border-radius:2px;
  }
  h5{
    text-align:center;
    margin-bottom:18px;
  }
  ul{
    margin-top:20px;
    li{
      padding:0 20px;
      font-size:15px;
      line-height:45px;
      border-bottom:1px solid #ECECEC;
      &.total{
        color:#378FFF;
      }
    }
  }
  .qx-result{
    background:rgba(55, 143, 255, 0.1);
    border-radius:6px;
    margin-top:40px;
    padding:16px;
    color:#378FFF;
    strong{
      display:block;
      text-align:center;font-weight: normal;
    }
  }
  .qx-btns{
    text-align:center;
    margin-top:110px;
    a{
      display:inline-block;
      line-height:50px;
      border-radius:30px;
      background:rgba(55, 143, 255, 0.1);
      color:#378FFF;
      width:200px;
      margin:0 10px;
      &.qx-btns-ok{
        background:#378FFF;
        color:#fff;
      }
    }
  }
}
.main-table-cont {
    overflow: hidden;
    border-bottom: 1px solid #c9dcfe;
    min-height: 257px;
}
.main-table-cont.qxOK{
  position:relative;
  &:after{
    content:'';position:absolute;right:20px;bottom:10px;background:url(~@/assets/images/icon/icon-agree.png) no-repeat 0 0;background-size:100% auto;width:90px;height:72px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/FunProduct.vue